import { FC } from "react";
import classNames from "classnames";
import IconlyFilledCategoryIcon from "@svg/new-design/bottom-tab-navigation/CategoryIconFilled";
import ProgramBook from "@svg/program-book";
import CategorySkeleton from "./category-skeleton";
import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";

export const ProgramSkeleton: FC = () => {
  return (
    <div className="relative animate-pulse ">
      <div className="py-6  lg:py-16 w-full bg-fds-canvas-primary overflow-x-hidden">
        <nav
          className={classNames(
            "flex items-center gap-1.5  border-b-2 border-fds-divider min-h-fds-52 h-fds-52 mb-0.5 px-2  sticky z-30 bg-fds-primary md:hidden"
          )}
        >
          <div className="w-10 h-10 bg-fds-secondary rounded-full" />
          <div className="h-5 w-2/3 bg-fds-secondary rounded-md" />
        </nav>

        <div className="section-container w-full flex flex-col lg:flex-row-reverse items-center justify-between mx-auto gap-4 px-4     md:px-8   lg:px-12">
          <div className="program-image-container relative flex justify-center bg-fds-disable rounded" />
          <div className="w-full md:w-1/2 flex flex-col gap-3">
            <div className="h-4     w-9/12 bg-fds-disable" />
            <div className="h-4     w-3/12 bg-fds-disable" />
            <div className="h-4     w-9/12 bg-fds-disable" />
            <div className="h-4     w-9/12 bg-fds-disable" />
            <div className="h-4     w-9/12 bg-fds-disable" />
            <div className="h-4     w-1/2 bg-fds-disable" />
          </div>
        </div>
      </div>

      <div className="section-container lg:px-12 w-full mx-auto pt-8   lg:pt-12">
        <div className="w-full flex flex-col lg:flex-row lg:gap-6">
          <div
            dir="rtl"
            className="p-5    w-full lg:w-1/3  rounded-12 bg-fds-primary border border-fds-cart sticky"
            style={{ top: 68 }}
            aria-busy="true"
            aria-live="polite"
          >
            <div className="flex gap-2  items-center">
              <IconlyFilledCategoryIcon
                width={16}
                height={16}
                className="text-fds-icon-secondary"
              />
              <RectangularSkeleton height={18} width={160} />
            </div>

            {/* Divider */}
            <div className="w-full bg-fds-disable h-0.5 my-4     animate-pulse" />

            {/* Rows */}
            <div className="flex flex-col gap-4    ">
              {Array(3)
                .fill("")
                .map((_, index) => (
                  <RectangularSkeleton key={index} height={16} width={100} />
                ))}
            </div>
          </div>
          <div
            dir="rtl"
            className="w-full bg-fds-canvas-primary p-3  md:px-5    md:py-3.5   flex flex-col gap-2  rounded-12 border border-fds-cart scroll-mt-24"
            aria-busy="true"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-1">
                <ProgramBook className="text-fds-on-brand-light-select pl-1 w-4     md:w-6" />
                <RectangularSkeleton height={18} width={120} />
              </div>
              <RectangularSkeleton
                width={20}
                height={20}
                className="rounded-6"
              />
            </div>

            {/* Collapsible Content */}
            <div className="flex w-full grow shrink-0 flex-col gap-2">
              {Array(3)
                .fill("")
                .map((_, index) => (
                  <CategorySkeleton key={index} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
